<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="card_list"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <path id="Path_8652" data-name="Path 8652" d="M0,0H22V22H0Z" fill="none" />
    <path
      id="Path_8653"
      data-name="Path 8653"
      d="M8,3.833l1.192-1.49A.917.917,0,0,1,9.908,2h3.519a.917.917,0,0,1,.716.344l1.191,1.49h0V4.75a.917.917,0,0,1-.917.917h-5.5A.917.917,0,0,1,8,4.75V3.833Z"
      transform="translate(-0.667 -0.167)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_8654"
      data-name="Path 8654"
      d="M18.667,11.333v-5.5A1.833,1.833,0,0,0,16.833,4H15M7.667,4H5.833A1.833,1.833,0,0,0,4,5.833V17.75a1.833,1.833,0,0,0,1.833,1.833h5.5m2.536-2.117a1.156,1.156,0,0,1,0-1.265,4.256,4.256,0,0,1,3.22-2.118A4.259,4.259,0,0,1,20.31,16.2a1.153,1.153,0,0,1,0,1.265,4.262,4.262,0,0,1-3.22,2.117A4.254,4.254,0,0,1,13.87,17.467Z"
      transform="translate(-0.333 -0.333)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_8655"
      data-name="Path 8655"
      d="M17.514,17.326a.13.13,0,1,1-.184,0,.129.129,0,0,1,.184,0M8,11h7.333M8,15.583H9.833"
      transform="translate(-0.667 -0.917)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
